import "./Loader.css";
const Loader = () => {
  return (
    <div>
      <div class="loader">
        <div class="duo duo1">
          <div class="dot dot-a"></div>
          <div class="dot dot-b"></div>
        </div>
        <div class="duo duo2">
          <div class="dot dot-a"></div>
          <div class="dot dot-b"></div>
        </div>
      </div>
    </div>
  );
};
export { Loader };
